export const CONSENT_KEY = "gabri_cookie_consent";
export const CONSENT_EVENT = "gabri-consent";

export function getConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch (err) {
    console.warn("Impossibile leggere il consenso cookie:", err);
    return null;
  }
}

// Aggiorna il consenso di Google Analytics (Consent Mode v2) in base alla scelta utente.
export function applyGtagConsent(value) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  const granted = value === "all";
  window.gtag("consent", "update", {
    ad_storage: granted ? "granted" : "denied",
    analytics_storage: granted ? "granted" : "denied",
    ad_user_data: granted ? "granted" : "denied",
    ad_personalization: granted ? "granted" : "denied",
  });
}

export function setConsent(value) {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch (err) {
    console.warn("Impossibile salvare il consenso cookie:", err);
  }
  applyGtagConsent(value);
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: value }));
}
